import React from "react";
import { connect } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { ErrorLog } from "../components/shared/ErrorLog";
import { ErrorModel } from "../models/ErrorModel";

interface Props {}

interface StateProps {
    errors: ErrorModel[];
}

interface DispatchProps {}

interface State {}

type PropsU = Props & StateProps & DispatchProps;

class ErrorLogContainerImpl extends React.PureComponent<PropsU, State> {
    render() {
        return <ErrorLog errors={this.props.errors} />;
    }
}

const mapStateToProps = (state: StoreState): StateProps => ({
    errors: state.errors,
});

export const ErrorLogContainer = connect(mapStateToProps)(ErrorLogContainerImpl);
